export const ScreenLayout = Object.freeze({
	Phone: 'phone',
	Tablet: 'tablet',
	Desktop: 'desktop',
});
